import Auth from '@Services/Auth';
import get from 'lodash/get';
import { accountReducerKey } from './AccountConstants';

export function account(state) {
  return state.get(accountReducerKey);
}

export function isLoading(state) {
  return account(state).get('isLoading');
}

export function username(state) {
  return account(state).get('username');
}

export function email(state) {
  return account(state).get('email');
}

export function passwordData(state) {
  return account(state).get('passwordData');
}

export function restrictedWords(state) {
  return account(state).get('restrictedWords');
}

export function isShibboleth() {
  const user = Auth && Auth.getUser();
  const accessType = get(user, 'details.loginDetails.accessType');
  if (accessType) {
    return accessType.indexOf('SHIBBOLETH') !== -1;
  }
  return false;
}
